/* tslint:disable */
/* eslint-disable */
/* @relayHash 044a67ec4d538b4d268bb79def5bd534 */

import { ConcreteRequest } from "relay-runtime";
export type DesignProfileBasicMutationInput = {
    serviceId: string;
    about?: string | null;
    email?: string | null;
    clientMutationId?: string | null;
};
export type profileEmailMutationVariables = {
    input: DesignProfileBasicMutationInput;
};
export type profileEmailMutationResponse = {
    readonly designProfileBasicMutation: {
        readonly tradeFirm: {
            readonly publicProfile: {
                readonly email: string | null;
            } | null;
        } | null;
    } | null;
};
export type profileEmailMutation = {
    readonly response: profileEmailMutationResponse;
    readonly variables: profileEmailMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DesignProfileBasicMutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "publicProfile",
  "storageKey": null,
  "args": null,
  "concreteType": "TradeFirmPublicProfileType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "email",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "profileEmailMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "designProfileBasicMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DesignProfileBasicMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "profileEmailMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "designProfileBasicMutation",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DesignProfileBasicMutationPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeFirm",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "profileEmailMutation",
    "id": "app-buyer-trade/267.0.0-2020-06-02T16:23:38.038Z/profileEmailMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'fb2ee3c3986c0ca07ce1e94f37912308';
export default node;
